exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DetailsTable_detailsTable_2ZGG {\n  font-family: Arial;\n  font-size: 13px;\n}\n", ""]);

// exports
exports.locals = {
	"detailsTable": "DetailsTable_detailsTable_2ZGG"
};